import {
	BaseError,
} from './BaseError';

export class GetSpecificationContactsOfferError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
